<template>
  <div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
      >
        <el-table-column property="createTime" label="时间"/>
        <el-table-column property="" label="举报人">
          <template #default="scope">
            <UserInfoList :row="scope.row" showList="name,uid"/>
          </template>
        </el-table-column>
        <el-table-column property="" label="具体原因" v-if="type == 7">
          <template #default="scope">
            <p>{{ scope.row.reasonType == 1?'无法添加':scope.row.reasonType == 2?'非本人微信/身份造假':scope.row.reasonType == 3?'微商/理财/销售（非交友目的）':scope.row.reasonType == 4?'其他':''}}</p>
          </template>
        </el-table-column>
        <el-table-column property="msg" label="举报内容"/>
        <el-table-column property="" label="图片">
          <template #default="scope">
            <el-space wrap>
              <el-image style="width: 40px; height: 40px" fit="cover" v-for="(item, index) in scope.row.imgList" :key="item.id" :src="item.smallImg" @click="showImg(index, scope.row.imgList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </el-space>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getReportUserPageList } from '@/api/url'
import { getFormData } from '@/api/api'
import ImgViewer from '../../../../assets/js/imageViewer'

export default {
  name: "InviteDetailDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,
      type: this.value.type?this.value.type:-1,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['relUserId'] = this.userId;
      param['type'] = this.type;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getReportUserPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
